import {
  AddCommentOutlined,
  AlternateEmail,
  BookOnline,
  CardMembership,
  CollectionsBookmarkOutlined,
  DashboardCustomizeOutlined,
  DeleteOutlined,
  Diversity3,
  DomainAddOutlined,
  EditOutlined,
  Facebook,
  HolidayVillageOutlined,
  Home,
  Info,
  Instagram,
  KeyOutlined,
  LocalLibrary,
  LocationOn,
  LoyaltyOutlined,
  MarkunreadMailbox,
  PersonAddAltOutlined,
  PersonOutlined,
  PhotoCamera,
  PointOfSale,
  PostAddOutlined,
  SchoolOutlined,
  Sell,
  ShoppingBasket,
  Spoke,
  StickyNote2Outlined,
  Style,
  TheaterComedy,
  TheaterComedyOutlined,
  WcOutlined,
} from '@mui/icons-material';
import { IMenuItem } from 'utils/models/interfaces';
import { datosTeatro } from 'content/site';

export const pestanias: IMenuItem[] = [
  {
    text: 'Inicio',
    path: '/',
    icon: Home,
  },
  {
    text: 'Quiénes Somos',
    path: '/quienes-somos',
    icon: Diversity3,
  },
  {
    text: 'Galería',
    path: '/galeria',
    icon: PhotoCamera,
  },
  {
    text: 'Talleres',
    path: '/galeria-talleres',
    icon: LocalLibrary,
  },
  {
    text: 'Alquiler de salas',
    path: '/alquiler-de-salas',
    icon: HolidayVillageOutlined,
  },
  {
    text: 'Hacete socio',
    path: '/hacete-socio',
    icon: CardMembership,
  },
  {
    text: 'Contacto',
    path: '/contacto',
    icon: Spoke,
  },
];

export const datosTeatroIconos: IMenuItem[] = [
  {
    text: 'Nombre',
    path: datosTeatro.nombre,
  },
  {
    text: 'Descripcion',
    path: datosTeatro.descripcion,
    icon: Info,
  },
  {
    text: 'Dirección',
    path: datosTeatro.direccion,
    icon: LocationOn,
    subtitulo: 'Dirección',
  },
  {
    text: 'Ciudad',
    path: datosTeatro.cpCiudad,
    icon: MarkunreadMailbox,
  },
  {
    text: 'Email',
    path: datosTeatro.email,
    icon: AlternateEmail,
  },
  {
    text: 'Instagram',
    path: datosTeatro.instagram,
    icon: Instagram,
  },
  {
    text: 'Facebook',
    path: datosTeatro.facebook,
    icon: Facebook,
  },
];

// DATOS DRAWER MENU
export const menuAdminListados: IMenuItem[] = [
  { text: 'Usuarios', path: 'usuarios', icon: WcOutlined },
  { text: 'Alquileres', path: 'alquileres', icon: HolidayVillageOutlined },
  { text: 'Talleres', path: 'talleres', icon: SchoolOutlined },
  { text: 'Ventas', path: 'ventas', icon: Style },
  { text: 'Espectáculos', path: 'espectaculos', icon: TheaterComedyOutlined },
  { text: 'Ganancias', path: 'ganancia', icon: LoyaltyOutlined },
  { text: 'Boletines', path: 'boletines', icon: StickyNote2Outlined },
];

export const menuAdminCrear: IMenuItem[] = [
  { text: 'Nuevo usuario', path: 'alta-usuario', icon: PersonAddAltOutlined },
  { text: 'Nuevo taller', path: 'alta-taller', icon: AddCommentOutlined },
  { text: 'Nuevo alquiler', path: 'alta-alquiler', icon: DomainAddOutlined },
  { text: 'Nuevo espectáculo', path: 'alta-espectaculo', icon: PostAddOutlined },
  { text: 'Nueva compra', path: 'elegir-espectaculo', icon: ShoppingBasket },
  { text: 'Nuevo boletín', path: 'boletin', icon: StickyNote2Outlined },
];

export const menuUsuario: IMenuItem[] = [
  { text: 'Modificar mis datos', path: 'editar', icon: EditOutlined },
  { text: 'Mis compras', path: 'miscompras', icon: BookOnline },
  { text: 'Mis talleres', path: 'mistalleres', icon: CollectionsBookmarkOutlined },
  { text: 'Cambiar mi contraseña', path: 'password', icon: KeyOutlined },
  { text: 'Darme de baja', path: 'baja', icon: DeleteOutlined },
];
export const menuAdminSitio: IMenuItem[] = [
  // { text: 'Modificar tipo elenco', path: 'editar-tipo-elenco', icon: TransferWithinAStation },
  { text: 'Modificar cuotas', path: 'cuotas', icon: PointOfSale },
  { text: 'Modificar descuentos', path: 'descuentos', icon: Sell },
  { text: 'Agregar género', path: 'generos', icon: TheaterComedy },
];
export const opcionesAdmin: IMenuItem[] = [
  { text: 'Dashboard', path: '/admin', icon: DashboardCustomizeOutlined },
  { text: 'Enviar boletín', path: '/admin/boletin', icon: StickyNote2Outlined },
  { text: 'Ganancia por ventas', path: '/admin/ventas', icon: LoyaltyOutlined },
];
export const opcionesAnonimo = [{ text: 'Iniciar sesión', path: 'login' }];
export const opcionesUsuario = [
  { text: 'Mi cuenta', path: '/usuario', icon: PersonOutlined },
  { text: 'Mis compras', path: '/usuario/miscompras', icon: BookOnline },
  { text: 'Mis talleres', path: '/usuario/mistalleres', icon: SchoolOutlined },
  { text: 'Modificar contraseña', path: '/usuario/password', icon: KeyOutlined },
];

